module.exports = __webpack_public_path__ + "img/worldmapmobile.90d82c4c.webp";